import {
  PenTool,
  Scissors,
  Compass,
  Wrench,
  Flame,
  Layers,
  Ruler,
} from "lucide-react";

const BENEFITS = [
  {
    icon: PenTool,
    title: "Produção sob desenho técnico",
    desc: "Fabricamos exatamente conforme o seu projeto, amostra ou especificação técnica.",
  },
  {
    icon: Scissors,
    title: "Corte a laser de alta precisão",
    desc: "Acabamento limpo e cortes dimensionais com tolerâncias industriais.",
  },
  {
    icon: Compass,
    title: "Dobra CNC padronizada",
    desc: "Dobras repetíveis com controle de ângulo para séries pequenas e recorrentes.",
  },
  {
    icon: Wrench,
    title: "Usinagem sob medida",
    desc: "Torneamento e fresagem para componentes críticos com padrão dimensional.",
  },
  {
    icon: Flame,
    title: "Soldagem industrial resistente",
    desc: "Uniões robustas com processos qualificados e controle visual do cordão.",
  },
  {
    icon: Layers,
    title: "Montagem final integrada",
    desc: "Conjunto finalizado pronto para aplicação, reduzindo etapas na sua operação.",
  },
  {
    icon: Ruler,
    title: "Controle dimensional rigoroso",
    desc: "Inspeção e verificação em cada etapa para garantir consistência entre lotes.",
  },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="relative py-20 sm:py-28 bg-white"
    >
      <div className="container-buzas">
        <div className="max-w-3xl">
          <span className="eyebrow">Benefícios técnicos</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-[var(--buzas-navy)]">
            Processos integrados para uma linha aeroviária mais segura
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[var(--buzas-muted)] leading-relaxed">
            Toda a cadeia de fabricação acontece internamente na Buzas — do
            corte a laser à montagem final. Isso reduz falhas, encurta prazos e
            garante padrão técnico consistente em cada peça entregue para
            oficinas aeronáuticas, hangares e operações de aviação agrícola.
          </p>
        </div>

        {/* Cards grid — 2/3/4 cols responsive */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {BENEFITS.map((b, i) => (
            <BenefitCard key={b.title} b={b} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function BenefitCard({ b, index }) {
  const { icon: Icon, title, desc } = b;
  return (
    <div
      data-testid={`benefit-card-${index}`}
      className="card-flat p-7 flex flex-col h-full group"
    >
      <div className="flex items-center justify-between mb-6">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-[rgba(26,43,86,0.05)] text-[var(--buzas-navy)] transition-colors group-hover:bg-[var(--buzas-navy)] group-hover:text-white">
          <Icon size={20} />
        </span>
        <span className="font-display text-xs font-bold text-[var(--buzas-muted)] tabular-nums opacity-60">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <h3 className="font-display text-[17px] font-bold text-[var(--buzas-navy)] leading-snug">
        {title}
      </h3>
      <p className="mt-3 text-[14px] text-[var(--buzas-muted)] leading-relaxed">
        {desc}
      </p>
    </div>
  );
}
